import UserServicesFactory from '../../user/Services/factory.js'
import {VehiclesMappersFactory} from '../../vehicles/Mappers/factory.js'
import {FormMappersFactory} from '../Mappers/factory.js'
import {FormRepositoriesFactory} from '../Repositories/factory.js'
import {FormServicesFactory} from '../Services/factory.js'
import {GetAdComplaintConfigFormUseCase} from './GetAdComplaintConfigFormUseCase.js'
import {GetCaptchaStatusFormUseCase} from './GetCaptchaStatusFormUseCase.js'
import {GetModelDetailFormConfigUseCase} from './GetModelDetailFormConfigUseCase.js'
import {GetSellVehicleConfigFormUseCase} from './GetSellVehicleConfigFormUseCase.js'

export default class FormUseCasesFactory {
  static getAdComplaintConfigFormUseCase = ({config}) =>
    new GetAdComplaintConfigFormUseCase({
      adComplaintConfigFormVOMapper: FormMappersFactory.adComplaintConfigFormValueObjectMapper({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      })
    })

  static getSellVehicleConfigFormUseCase = ({config}) =>
    new GetSellVehicleConfigFormUseCase({
      config,
      sellVehicleConfigFormVOMapper: FormMappersFactory.sellVehicleConfigFormValueObjectMapper({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      fromSpecsParamsToSearchUrlValueObjectMapper: VehiclesMappersFactory.fromSpecsParamsToSearchUrlValueObjectMapper({
        config
      }),
      specsFormService: FormServicesFactory.getSpecsFormService({config})
    })

  static getCaptchaStatusFormUseCase = ({config}) =>
    new GetCaptchaStatusFormUseCase({
      getCaptchaStatusFormService: FormServicesFactory.getCaptchaStatusFormService({config})
    })

  static getModelDetailFormConfigUseCase = ({config}) =>
    new GetModelDetailFormConfigUseCase({
      repository: FormRepositoriesFactory.hTTPFormRepository({config})
    })
}
